<template>
  <div class="main-wrapper">

    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span class="font-weight-600 text-slate-300" style="color:#1f2937;">{{ $t("logo.prefix") }} </span><span class="font-weight-bold text-slate-500" style="color: #fff; font-weight: bold; background-color: #004A59; padding: 6px; border-radius: 5px">{{ $t("logo.suffix") }}</span>
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h6 class="text-muted" style="color: darkgreen">Set up your new password...</h6>
              <div class="mt-4">
                <div v-if="success === true && message" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetMessage">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div v-if="success === false && message" class="alert alert-danger alert-dismissible fade show" role="alert">
                  {{ message }}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetMessage">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
            </div>

            <form action="">
              <div class="form-group mb-4"  style="position: relative;">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  id="password"
                  required
                  v-model="password"
                  name="password"
                  placeholder="Enter your password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="togglePassword($event)"
                >

                  <i v-if="showPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
							</div>
              <div class="form-group mb-4"  style="position: relative;">
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  class="form-control"
                  id="confirmPassword"
                  required
                  v-model="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm your password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="toggleConfirmPassword($event)"
                >

                  <i v-if="showConfirmPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
							</div>
              <div class="text-center">
                <button class="btn btn-primary btn-block account-btn" type="button" @click="resetPassword()">Reset Password</button>
              </div>
            </form>
            <div class="login-or">
              <span class="or-line"></span>
              <span class="span-or">or</span>
            </div>
            <div class="text-center dont-have">Already registered? <router-link to="/login"> Login</router-link></div>
            <div class="text-center dont-have">
              <div>
                <small id="terms-footnote" class="footnote">
                  By continuing, you confirm you have read and agree to the <a href="https://salesdue.com/privacy">privacy policy</a> and  <a href="https://salesdue.com">terms and conditions</a> that govern your usage of our services.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authServiceApi from "../../service/AuthServiceApi.js"
import {errorCodes} from "../../interceptors/codes";

export default {
  name: "Forgot-password",
  data() {
    return {
      token: undefined,
      success: undefined,
      message: undefined,
      password: undefined,
      confirmPassword: undefined,
      showPassword: false,
      showConfirmPassword: false
    };
  },
  methods: {
    togglePassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword
    },
    toggleConfirmPassword(e){
      e.preventDefault();
      this.showConfirmPassword = !this.showConfirmPassword
    },
    login(){
      this.$router.push('/login');
    },
    resetPassword() {
      if(this.password !== this.confirmPassword){
        Swal.fire({
          icon: 'warning',
          title: 'Failed',
          text: 'Password do not match',
          footer: '<a href="">Please try again</a>'
        })
        return
      }
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });      
      let data = {
        token: this.token,
        password: this.password,
        confirmPassword: this.confirmPassword,
        domain: location.host
      }
      authServiceApi.resetPassword(data)
        .then(response => {
          let success = response.data.code === 'SUCCESS';
          if (success){
            this.resetMessage()
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'You will now be redirected to login page',
              confirmButtonText: 'OK',
              footer: '<a href="">Need help?</a>'
            }).then(()=>{
              this.$router.push("/login");
            })
          } else {
            this.success = false
            this.message = response.data.description
          }
        })
        .catch(e => {
          console.log("Error: ", e)
          this.success = false
          const code = e.response.status;
          const error = errorCodes[code];
          this.message = code === 400 ? (e.response.data.description || e.response.data.narrative) : error.description
        }).finally(() => {
        loader.hide()
      })
    },
    resetMessage(){
      this.message = ""
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    if (this.token){
      this.verifyAccount()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue